import styled, { createGlobalStyle } from 'styled-components';

interface ButtonProps {
  $isHidden?: string;
}

export const FontStyles = createGlobalStyle`
    * {
        font-family: 'Factor A', 'DM Sans', sans-serif;
        box-sizing: border-box;
        color: ${(props: any) => props.theme.colors.gray0};
    }

    html, 
    body {
        padding: 0;
        margin: 0;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;
        color: ${(props: any) => props.theme.colors.gray0};
        background-color: #fff;
        /* width: 100vw;
        height: 100vh;
        height: var(--app-height); */
        /* overflow: hidden; */
        /* overflow: -moz-hidden-unscrollable;
        -webkit-overflow-scrolling: hidden; */
    }
 
    /* Chrome, Safari, Edge, Opera */
    input::-webkit-outer-spin-button,
    input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    /* Firefox */
    input[type=number] {
        -moz-appearance: textfield;
    }

    /* :root {
      --app-height: 100%;
    } */
    #root {
      box-sizing: border-box;
      /* overflow: hidden; */
    }
`;

interface TitleProps {
  $align?: 'left' | 'center' | 'right';
}

export const Title = styled.div<TitleProps>`
  font-size: 18px;
  font-weight: 500;
  text-align: ${(props) => props.$align || 'center'};
  padding: 15px;
  line-height: 1.25rem;

  @media (max-width: 450px) {
    padding: 10px 0;
  }
`;

export const Subtitle = styled.div<TitleProps>`
  text-align: ${(props) => props.$align || 'center'};
  color: ${(props) => props.theme.colors.gray6};
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
`;

export const MainButtonSection = styled.div`
  height: 100%;
  flex: 1 1 auto;
  display: flex;
  padding-top: 15px;
`;

export const MainButton = styled.button<ButtonProps>`
  display: ${(props) => (props.$isHidden ? 'none' : 'flex')};
  width: 100%;
  justify-content: center;
  align-items: center;
  color: ${(props) => props.theme.colors.white};
  height: 43px;
  background: ${(props) =>
      props.disabled ? props.theme.colors.red9 : props.theme.colors.red6}
    0 0 no-repeat padding-box;
  border-radius: 26px;
  border: 1px solid
    ${(props) =>
      props.disabled ? props.theme.colors.red9 : props.theme.colors.red6};
  padding: 10.5px 0.75rem;
  margin-top: auto;
  margin-bottom: 1rem;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  &:hover {
    background: ${(props) =>
        props.disabled ? props.theme.colors.red9 : props.theme.colors.red7}
      0 0 no-repeat padding-box;
    border: 1px solid
      ${(props) =>
        props.disabled ? props.theme.colors.red9 : props.theme.colors.red7};
  }
  &:focus-visible {
    outline: none;
    color: ${(props) => props.theme.colors.gray0};
    background-color: ${(props) => props.theme.colors.red6};
  }
`;

export const MainLink = styled.a<ButtonProps>`
  display: ${(props) => (props.$isHidden ? 'none' : 'block')};
  width: 100%;
  color: ${(props) => props.theme.colors.red11};
  height: 43px;
  background: ${(props) => props.theme.colors.red6} 0 0 no-repeat padding-box;
  border-radius: 26px;
  border: 1px solid ${(props) => props.theme.colors.red6};
  padding: 0.6rem;
  margin-top: auto;
  margin-bottom: 1rem;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
  vertical-align: center;
  &:hover {
    background: ${(props) => props.theme.colors.red7} 0 0 no-repeat padding-box;
    border: 1px solid ${(props) => props.theme.colors.red7};
  }
  &:focus {
    background: #ffffff 0 0 no-repeat padding-box;
    border: 1px solid ${(props) => props.theme.colors.red8};
    color: ${(props) => props.theme.colors.gray0};
  }
`;

export const AppText = styled(MainButton)`
  border: none !important;
  background: transparent;
  color: #333030;
  cursor: initial;
  :hover {
    background: transparent;
    border: none;
  }
`;

export const SecondaryButton = styled.button<ButtonProps>`
  display: ${(props) => (props.$isHidden ? 'none' : 'block')};
  width: 100%;
  color: #ffffff;
  height: 43px;
  color: ${(props: any) => props.theme.colors.red7};
  background: none;
  border: none;
  margin-bottom: 1rem;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
`;

export const QuitLink = styled.a<ButtonProps>`
  display: ${(props) => (props.$isHidden ? 'none' : 'block')};
  width: 100%;
  color: #ffffff;
  height: 43px;
  color: ${(props: any) => props.theme.colors.red7};
  background: none;
  border: none;
  margin-bottom: 1rem;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  text-decoration: none;
  text-align: center;
`;

export const SeparationLine = styled.div`
  margin: 6px 0 9px;
  border-top: 1px solid #e1eaf1;
  width: 100%;
  z-index: 10;

  @media (max-width: 320px) {
    margin: 2px 0;
  }
`;

interface EuroIconProps {
  $isDisabled?: boolean;
}
export const EuroIcon = styled.img<EuroIconProps>`
  position: absolute;
  right: 16px;
  top: 28px;
  opacity: ${(props) => (props.$isDisabled ? '0.4' : '1')};
`;

export const MonthText = styled.div`
  position: absolute;
  right: 16px;
  top: 22px;
  pointer-events: none;
`;

export const LinkButton = styled.a`
  color: ${(props: any) => props.theme.colors.red7};
  background: inherit;
  border: none;
  font-size: 14px;
  font-weight: ${(props) => props.theme.fontWeight.textBold};
  text-decoration: underline;
  cursor: pointer;
`;

interface TextProps {
  $fontSize?: number;
  $align?: string;
  $color?: string;
  // fontSize?: number;
  // align?: string;
  // color?: string;
}

export const TextBold = styled.span<TextProps>`
  font-size: ${(props) => props.$fontSize}px;
  font-weight: ${(props) => props.theme.fontWeight.textBold};
  text-align: ${(props) => props.$align};
  color: ${(props) =>
    props.$color ? props.theme.colors[props.$color] : props.theme.colors.gray0};
`;

export const TextMedium = styled.span<TextProps>`
  font-size: ${(props) => props.$fontSize}px;
  font-weight: ${(props) => props.theme.fontWeight.textMedium};
  text-align: ${(props) => props.$align};
  color: ${(props) =>
    props.$color ? props.theme.colors[props.$color] : props.theme.colors.gray0};
`;

export const TextRegular = styled.span<TextProps>`
  font-size: ${(props) => props.$fontSize}px;
  font-weight: ${(props) => props.theme.fontWeight.textRegular};
  text-align: ${(props) => props.$align};
  color: ${(props) =>
    props.$color ? props.theme.colors[props.$color] : props.theme.colors.gray0};
`;

export const GreenCardHelpOverlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  z-index: 11;
  border-radius: inherit;
  animation: help-overlay-fade 200ms ease-out;
`;